import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-diceIcons-D6',
    templateUrl: './D6.svg',
    styleUrls: ['./diceIcons-D6.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiceIconsD6Component { }
